import {combineReducers} from '@reduxjs/toolkit'
import {expressApi} from '../api/express-api'
import {fiasApi} from '../api/fias-api'
import dataForRender from './data-for-render'
import regions from './regions'

const rootReducer = combineReducers({
    expressApi: expressApi.reducer,
    fiasApi: fiasApi.reducer,
    dataForRender: dataForRender,
    regions: regions,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
